export default __webpack_public_path__ + "static/media/Vending3.9f21c764.png";